/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Title_ExperienceInputs */

const en_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience`)
};

const ar_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخبرات`)
};

const bn_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অভিজ্ঞতা`)
};

const de_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrung`)
};

const es_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia`)
};

const fr_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expérience`)
};

const pt_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência`)
};

const zh_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经验`)
};

const tr_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneyim`)
};

const ru_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опыт`)
};

const pl_resume_title_experience = /** @type {(inputs: Resume_Title_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doświadczenie`)
};

/**
* | output |
* | --- |
* | "Experience" |
*
* @param {Resume_Title_ExperienceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_title_experience = /** @type {((inputs?: Resume_Title_ExperienceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Title_ExperienceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_title_experience(inputs)
	if (locale === "bn") return bn_resume_title_experience(inputs)
	if (locale === "de") return de_resume_title_experience(inputs)
	if (locale === "es") return es_resume_title_experience(inputs)
	if (locale === "fr") return fr_resume_title_experience(inputs)
	if (locale === "pt") return pt_resume_title_experience(inputs)
	if (locale === "zh") return zh_resume_title_experience(inputs)
	if (locale === "tr") return tr_resume_title_experience(inputs)
	if (locale === "ru") return ru_resume_title_experience(inputs)
	if (locale === "pl") return pl_resume_title_experience(inputs)
	return en_resume_title_experience(inputs)
});